import React, { useState } from "react";
import { GlobalStyle } from "./styles";
import NavComponent from "./components/nav";
import ContentComponent from "./components/content";
import HeaderComponent from "./components/header";

export default function App() {
  const [selected, setSelected] = useState("all");

  return (
    <>
      <GlobalStyle />
      <HeaderComponent />
      <NavComponent selected={selected} setSelected={setSelected} />
      <main>
        <ContentComponent selected={selected} />
      </main>
    </>
  );
}
